export function getSearchParams(state) {
	return state.params;
}

export function getResult(state) {
	return state.result;
}

export function getResultIsLoading(state) {
	return state.loading;
}

export function getError(state) {
	return state.error;
}

export function getChargeBeeFeatureFlagEnabled(state) {
	return state.chargeBeeFeatureFlagEnabled;
}

export function getResultsPage(state) {
	return state.resultsPage;
}

export function getResultsPerPage(state) {
	return state.resultsPerPage;
}

export function getResultsSortColumn(state) {
	return state.resultsSort;
}

export function getResultsSortDirection(state) {
	return state.resultsSortDirection;
}

export function getResultsTotal(state) {
	return state.resultsTotal;
}
